<template>
  <div id="header" class="container-fuild">
    <div>
      <div class="MyHeader" @mouseleave="mouseleave">
        <div ref="MyHeader_content" class="MyHeader_content">
          <img src="@/assets/img/logo_black.png"  @click="BackHome()">
          <div class="menu">
            <div class="item" v-for="(item, index) in menu" :key="index" :class="{ item_active: $route.name.indexOf(item.name) != -1 }"
                 @mouseenter="mouseenter(item, index)">
              <div class="text" @click="route(item, index)">
                <el-button class="button" size="mini">{{ item.title }}</el-button>
                <img class="text-img" tabindex="0" v-if="item.child" style="width: 8px;height: 4px;" src="@/static/arrowHome.png" >
              </div>
              <div :ref="'secondary_'+index" class="secondary">
                <div v-if="item.title === '解决方案'" class="secondary_content">
                  <div class="nav">
                    <div style="width: 1200px;height: 260px">
                      <div class="nav-child-box" style="margin-left: 190px">
                        <div class="child-box"  v-for="(item,index) in navChildList" :key="index">
                          <div class="nav-child-box-title" style="display: flex; align-items: center">
                            <a class="box-title" @click="go(item)">{{ item.title }}</a>
                            <img class="nav-child-box-img" src="@/static/homeSvg.svg">
                          </div>
                          <div class="box-line"></div>
                          <div class="box-text">应用案例</div>
                          <div v-for="citem in item.child" :key="citem.path">
                            <a class="box-child-text" @click="route(citem)">{{citem.name}}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="item.title === '核心产品'" class="secondary_content">
                  <div class="nav">
                    <div style="width: 1200px;height: 260px;">
                      <div class="nav-child-box" style="margin-left: 300px">
                        <div class="child-box"  v-for="(item,index) in navCoreList" :key="index">
                          <div class="box-title" @click="route(item)">{{ item.title }}</div>
                          <div class="box-line"></div>
                          <div v-for="citem in item.child" :key="citem.path">
                            <p class="box-child-text" @click="go(citem)">{{citem.name}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "应用案例",
          path: "/applications",
          children: [
            {
              name: "智能小镇管理系统",
              path: "/applications/smartTown",
              children: [
                {
                  name: "智能小镇管理系统",
                  path: "/applications/smartTown"
                },
                {
                  name: "大数据管理系统",
                  path: "/applications/bigData"
                }
              ]
            },
            {
              name: "大数据管理系统",
              path: "/applications/bigData"
            }
          ]
        },
        {
          name: "解决方案",
          path: "/service",
          children: []
        },
        {
          name: "核心产品",
          path: "/CoreProducts",
          children: []
        },
        {
          name: "关于我们",
          path: "/contactus",
          children: []
        }
      ],
      menu: [
        {
          title: "首页",
          name: "home",
          path: "/",
        },
        {
          title: "解决方案",
          path: "/service",
          child: [
            {
              name: "home",
              path: "/",
            }
          ]
        },
        {
          title: "核心产品",
          name: "ProductFace",
          path: "/ProductFace",
          child: [
            {
              name: "home",
              path: "/",
            }
          ]
        },
        {
          title: "关于我们",
          name: "contactus",
          path: "/contactus",
        },
      ],
      menuChild: [
        {
          name: '智慧文旅'
        },
      ],
      navChildList: [
        {
          title: '一体化平台',
          path: '/ApplicationTravelSeven',
          type: '',
          child: [
            {
              name: '一体化集成平台',
              path: '/ApplicationTravelSeven',
            }
          ]
        },
        {
          title: '智慧商旅',
          path: '/ServiceTravel',
          type: '',
          child: [
            {
              name: '铁路集团智慧商旅平台',
              path: '/ApplicationTravelOne',
            },
            {
              name: '实名核验闸机',
              path: '/ApplicationTravelThere',
            },
            // {
            //   name: '一体化集成平台',
            //   path: '/ApplicationTravelSeven',
            // }
          ]
        },
        {
          title: '智慧文旅',
          path: '/ServiceWenBrigade',
          type: '',
          child: [
            {
              name: '铁游宝平台',
              path: '/ApplicationTravelFour',
            },
            {
              name: '景区票务综合管理平台',
              path: '/ApplicationTravelFive',
            },
            {
              name: '景区检票系列',
              path: '/ApplicationTravelFive',
            }
          ]
        },
        {
          title: '智慧工地',
          path: '/ServiceConstruction',
          type: '',
          child: [
            {
              name: '智慧工地系统',
              path: '/ApplicationTravelEight',
            },
            {
              name: '数字化管理平台',
              path: '/ApplicationTravelSix'
            }
          ]
        },
        {
          title: '智慧防疫',
          path: '/ApplicationServicePlague',
          type: 'plague',
          child: [
            {
              name: '智慧疫情防控管理平台',
              path: '/ApplicationServicePlague'
            }
          ]
        },
      ],
      navCoreList: [
        {
          title: '人脸识别终端系列',
          path: '/ProductFace',
          child: [
            {
              name: '人脸门禁系列',
              path: '/ProductFace',
              type: 'face',
            },
            {
              name: '智慧防疫系列',
              path: '/ProductFace',
              type: 'control',
            },
            {
              name: '工地专用系列',
              path: '/ProductFace',
              type: 'construction',
            }
          ]
        },
        {
          title: '便携式终端系列',
          path: '/ProductPortable',
          child: [
            {
              name: '刷卡检票设备系列',
              path: '/ProductPortable',
              type: 'portable',
            },
            {
              name: '扫码支付系列',
              path: '/ProductPortable',
              type: 'pay',
            },
            {
              name: '景区检票系列',
              path: '/ProductPortable',
              type: 'spot',
            }
          ]
        },
        {
          title: '高铁自助闸机系列',
          path: '/ProductSpeed',
          type: 'speed',
          child: [
            {
              name: '自助闸机系列',
              path: '/ProductSpeed',
            }
          ]
        }
      ]
    };
  },
  watch: {
    $route: {
      handler(v) {
        this.$nextTick(() => {
          this.mouseleave();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.mouseleave();
    });
  },
  methods: {
    BackHome() {
      this.$router.push({ path: '/home'})
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    route(item) {
      // this.$router.push({path: item.path, query: {type: item.type}})
      this.$router.push({
        path: item.path,
      })
    },
    go(item) {
      this.$router.push({
        path: item.path,
        query:{
          type: item.type
        }
      })
    },
    mouseenter(item, index) {
      this.secondaryTop();
      if (item.child) {
        this.$refs["secondary_" + index][0].style.height =
          this.$refs.MyHeader_content.clientHeight + 260 + "px";
      }
    },
    mouseleave() {
      this.secondaryTop();
    },
    secondaryTop() {
      for (const i in this.menu) {
        this.$refs["secondary_" + i][0].style.top = this.$refs.MyHeader_content.clientHeight + "px";
        this.$refs["secondary_" + i][0].style.height = "0";
      }
    },
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #ffffff;
  transition: all ease 0.6s;
}
#header .header-top {
  /*height: 50px;*/
  /*color: #fff;*/
  /*font-size: 12px;*/
  /*line-height: 50px;*/
  /*background: #474747;*/
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 100px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 74px;
  height: 61px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  /*cursor: pointer;*/
  /*background: #ccc;*/
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    /*color: #fff;*/
    /*height: 50px;*/
    /*font-size: 20px;*/
    /*line-height: 50px;*/
    /*background: #474747;*/
    /*position: relative;*/
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    /*position: absolute;*/
    /*top: 50px;*/
    /*left: 0;*/
    /*width: 100%;*/
    /*background: #474747;*/
    /*z-index: 9999999;*/
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    /*height: 40px;*/
    /*line-height: 40px;*/
    /*border-bottom: 1px solid #ccc;*/
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
.MyHeader {
  width: 100%;
  height: 100px;
  position: sticky;
  top: 0;
  left: 0;
  background-color: #ffffff;
  z-index: 2000;
  position: fixed;
}

.MyHeader_content {
  max-width: 1200px;
  margin: auto;
  height: 100px;
  display: flex;
  align-items: center;
  color: #0F1012;
  z-index: 1;
  background-color: #ffffff;
}

.logo {
  height: 50px;
}

.menu {
  display: flex;
  align-items: center;
  margin-left: 60px;
}

.item {
  font-size: 18px;
  cursor: pointer;
}

.item >>> * {
  transition: 0.2s all;
}

.item + .item,
.tag + .tag {
  margin-left: 38px;
}


.item:hover,
.item_active {
  color: #A0A2AA;
}

.item_active .line {
  width: 100%;
}

.item:hover .line {
  width: 100%;
}

.secondary {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  height: 400px;
  background-color: #ffffff;
  transition: 0.3s all;
  overflow: hidden;
}

.secondary_content {
  height: 260px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}

.tag {
  color:  #0F1012;
  padding: 25px 0;
  cursor: pointer;
}

.tag:hover {
  color:  #0F1012;
}
.text {
  display: flex;
  align-items: center;
  position: relative;
}
.tag_active {
  color:  #0F1012;
}
.box{
  display: flex;
  justify-content: center;
  background: #FFFFFF;
}
.nav-box{
  width: 1200px;
  height: 260px;
  background: #ffffff;
}
.nac-box-title{
  display: flex;
  height: 20px;
  margin-top: 16px;
  margin-left: 167px;
  height: 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  color: #999999;
}
.nav-box-child{
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  margin-left: 167px;
}
.child-item{
  width: 56px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;

  /* 主题色 */
  color: #212121;
}
.nav-box-line{
  margin-left: 26px;
  width: 2px;
  height: 186px;
  background: #F5F5F5;
}
.nav-box-right{
  margin-left: 26px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  padding: 0px;
}

.right{
  height: 24px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: #606060;
}
.child-item:hover, nav-box-right{
  color:  #0A55FF;
}
.nav{
  width: 200px;
  height: 200px;
}
.nav-box-center{
  margin-top: 16px;
  margin-left: 167px;
}
.libt{
  display: flex;
}
.libt-text{
  width: 56px;
  height: 40px;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  color: #212121;
}
.libt-text:hover {
  color: #2C7EF9;
}
.libt p{
  color: #606060;
  display: block;
}
.libt p:hover{
  color: #2C7EF9;
}
.droplist{
  display: none;
  margin-left: 52px;
}

.text:hover img{
  -moz-transform:rotate(-180deg);
  -webkit-transform:rotate(-180deg);

}

.libt:hover .droplist{
  display: block;
}
.el-button {
  background: Transparent;
  color: #A0A2AA;
}
.el-button:focus {
  color: #2C2C34;
}
.el-button::after{
  border: 0;
}
.text .el-button--mini {
  border: none;
}
.button {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
}
.nav {
  width: 100%;
  height: 260px;
  display: flex;
  justify-content: center;
  border-radius: 0px 0px 4px 4px;
  background: #FFFFFF;
}
.nav-child-box {
  display: flex;
  width: 1200px;
  height: 260px;
  background: #FFFFFF;
  margin-right: 400px;
}
.child-box{
  width: 138px;
  margin-left: 60px;
}
.box-title {
  display: flex;
  align-items: center;
  margin-top: 16px;
  height: 20px;
  margin-bottom: 18px;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  color: #2C2C34;
}
.box-text {
  margin-top: 27px;
  height: 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 10px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  color: #9E9E9E;
}
.box-child-text{
  margin-top: 16px;
  height: 20px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  color: #212121;
}
.box-title:hover {
  font-size: 17px;
}
.box-child-text:hover {
  color: #2C7EF9;
  font-size: 13px;
}
.box-line{
  width: 138px;
  height: 1px;
  background: #F5F5F5;
}
.nav-child-box-img{
  width: 12px;
  height: 12px;
  margin-bottom: 4px;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue